// We need to import the CSS so that webpack will load it.
// The MiniCssExtractPlugin is used to separate it out into
// its own CSS file.
import "../css/app.scss"

// webpack automatically bundles all modules in your
// entry points. Those entry points can be configured
// in "webpack.config.js".
//
// Import deps with the dep name or local files with a relative path, for example:
//
//     import {Socket} from "phoenix"
//     import socket from "./socket"
//
import "phoenix_html"
import {Socket} from "phoenix"
import NProgress from "nprogress"
import {LiveSocket} from "phoenix_live_view"
import {InitToast} from "./init_toast.js"
import InitDropzone from "./init_dropzone.js"
import Chat from './chat_room.js'
import BroadcasterComponent from './broadcast/broadcaster_component.js'
import Cam2CamControls from './broadcast/cam2cam_controls.js'
import PlayerComponent from './broadcast/player_component.js'
import Checkout from './checkout.js'
import AnimationHooks from './animation_hooks.js'
import Termometer from './thermometer.js'
import TicketShowPassword from './ticket_show_password.js'
import UserContextMenu from './user_context_menu.js'
import BannedWordsComponent from './banned_words.js'
import TippyContent from './tippy_content.js'
import BlockedCountries from './blocked_countries.js'
import ShowTimer from './show_timer.js'
import LovenseComponent from './lovense.js'
import UploadFile from './upload_file.js'
import OneSignalPrompt from './one_signal_prompt'
import FetchCurrentTimezone from './fetch_current_timezone'
import CustomCheckbox from './custom_checkbox'
import StanaloneSelect from './standalone_select'
import InfiniteScroll from './infinite_scroll'
import Cropper from './cropper'
import StoryPlayer from './story_player'
import Uploaders from './uploaders'
import RecaptchaSubmit from './recaptcha'
import './fa_icons.js'

let Hooks = {}
Hooks.InitToast = InitToast
Hooks.Dropzone = InitDropzone
Hooks = {
  ...Hooks, ...Chat, ...BroadcasterComponent, ...PlayerComponent, ...Checkout,
  ...AnimationHooks, ...Termometer, ...TicketShowPassword, ...UserContextMenu, ...BannedWordsComponent,
  ...TippyContent, ...BlockedCountries, ...Cam2CamControls, ...ShowTimer, ...LovenseComponent, ...UploadFile,
  ...OneSignalPrompt, ...FetchCurrentTimezone, ...CustomCheckbox, ...StanaloneSelect, ...InfiniteScroll,
  ...Cropper, ...StoryPlayer, ...RecaptchaSubmit
}

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")
let liveSocket = new LiveSocket("/live", Socket, {
  uploaders: Uploaders,
  hooks: Hooks,
  params: {_csrf_token: csrfToken},
  dom: {
    onBeforeElUpdated(from, to){
      // AlpineJS v2
      if (from.__x) window.Alpine.clone(from.__x, to);
      // AlpineJS v3
      if (from._x_dataStack) window.Alpine.clone(from, to);

    }
  }
})

// Show progress bar on live navigation and form submits
window.addEventListener("phx:page-loading-start", info => NProgress.start())
window.addEventListener("phx:page-loading-stop", info => NProgress.done())

// connect if there are any LiveViews on the page
liveSocket.connect()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import {createPopper} from "kutty/src/js/popper"
window.Popper = {createPopper}
import "kutty/src/js/components/tooltip"


if (window.location.protocol == "https:" && window.location.search != "?debug" && window.location.hostname.indexOf("local") == -1 ) {
  console.log = function(){};
  window.console.log = function(){};
} else {
  liveSocket.enableDebug()
}
